<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-6 text-sm-right">
            <button  *hasPermission="{app: constant.SUBSISTEMAS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect"
              (click)="openModalNew();" data-bs-toggle="modal"
              data-bs-target="#modalEdit"><i class="fas fa-plus fa-lg mr-1"></i>
              Nuevo</button>
          </div>
        </div>
      </div>

      <div class="container card-body table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
          class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Ponderación</th>
              <th>Aporta valor</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let subSistem of subsistemas; let indice=index">
              <td>{{indice + 1}}</td>
              <td>{{subSistem.nombre}}</td>
              <td>{{subSistem.descripcion}} </td>
              <td>{{subSistem.ponderacion}}</td>
              <td>{{subSistem.aportaValor}}</td>
              <td>{{((subSistem.estado == '1')? 'Activo': 'Inactivo')}}</td>
              <td class="text-center">
                <div class="row">
                  <button *hasPermission="{app: constant.SUBSISTEMAS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar"
                    class="btn btn-sm btn-link waves-effect  col px-1"
                    title="Editar este registro" (click)="edit(subSistem)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>

                  <button  *hasPermission="{app: constant.SUBSISTEMAS, permission: [constant.BORRAR]}" type="button"
                    class="btn btn-sm btn-link waves-effect col px-1"
                    title="Eliminar este registro"
                    (click)="delete(subSistem.idSprSubsistema)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<jw-modal id="{{nameModal}}">
  <div class="modal-dialog" style="padding-top: 5%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">SUBSISTEMAS</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"
          (click)="closeModal();" aria-label="Close"></button>
      </div>
      <div class="modal-body p-2">

        <form class="needs-validation" novalidate id="formSubsistema"
          [formGroup]="formSubsistema">
          <div class="row">
            <input type="hidden" id="idSprSubsistema"
              formControlName="idSprSubsistema">
            <div class="form-floating mb-3">
              <input id="idSprSubsistema" type="text" maxlength="250"
                class="form-control" required="true"
                formControlName="nombre"
                oninput="this.value = this.value.toUpperCase();"
                [ngClass]="{
                              'is-invalid': this.formSubsistema.get('nombre')?.errors && this.submitted,
                              'is-valid': !this.formSubsistema.get('nombre')?.errors,
                            }" />
              <small class="invalid-feedback"
                *ngIf="this.formSubsistema.get('nombre')?.errors?.['required'] && this.submitted">
                Campo requerido</small>
              <label for="idSprPermiso" class="col-form-label text-md-right"><b>Nombre</b>
              </label>
            </div>
            <div class="form-floating mb-3">
              <textarea maxlength="500" type="text" id="descripcion"
                class="form-control"
                formControlName="descripcion" autofocus
                placeholder="descripcion"
                [ngClass]="{
                                    'is-valid': !!this.formSubsistema.value.descripcion
                                  }"></textarea>
              <label for="descripcion">Descripción</label>
            </div>

            <div class="form-floating mb-3">
              <input type="number" min="0" max="200" maxlength="3"
                onkeydown="return false" name="ponderacion" id="ponderacion"
                placeholder="Solo caracteres
                            Numericos" class="form-control"
                formControlName="ponderacion"
                required autofocus placeholder="ponderacion"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && subSistForm['ponderacion'].errors}">
              <small class="invalid-feedback"
                *ngIf="submitted && subSistForm['ponderacion'].errors">Campo
                requerido</small>
              <label for="ponderacion">Ponderación</label>
            </div>

            <div class="mb-3">
              <label class="form-label">Aporta valor</label>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check mb-2">
                    <input type="radio" class="form-check-iput"
                      name="aportaValor" id="avSi" value="S"
                      formControlName="aportaValor"
                      checked required>
                    <label for="avSi"> Si</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check mb-2">
                    <input type="radio" class="form-check-iput"
                      name="aportaValor"
                      formControlName="aportaValor" id="avNo" value="N">
                    <label for="avNo"> No</label>
                  </div>
                </div>
              </div>
              <small class="invalid-feedback"
                *ngIf="submitted && subSistForm['aportaValor'].errors">Campo
                requerido</small>

            </div>
            <div class="form-floating mb-3">
              <select id="estado" class="form-select" formControlName="estado"
                required="true" [ngClass]="{
                                'is-invalid': this.formSubsistema.get('estado')?.errors && this.submitted,
                                'is-valid': !this.formSubsistema.get('estado')?.errors,
                              }">
                <option value="1" selected>Activo</option>
                <option value="2">Inactivo</option>
              </select>
              <label for="estado">Estado </label>
              <small class="invalid-feedback"
                *ngIf="this.formSubsistema.get('estado')?.errors?.['required'] && this.submitted">
                Campo
                requerido</small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect"
          (click)="closeModal();" data-bs-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-info waves-effect waves-light"
          (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="del" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>
